import { useLocalizedUnlockDuration } from '@domains/staking/dappStaking'

const UnlockDuration = () => <>{useLocalizedUnlockDuration()}</>

export default UnlockDuration
